import { DateRangeFlexSalesProps } from '../../DateRangeFlexSales';
import {
  changePendingInterfacesFilterEndBusinessDate,
  changePendingInterfacesFilterStartBusinessDate,
  reportPendingInterfacesFilterEndBusinessDateSelector,
  reportPendingInterfacesFilterStartBusinessDateSelector,
} from '../../../state';
import ReportBusinessDateRangeFilter from '../../ReportFilters/filters/BusinessDateRangeFilter';

type BusinessDateRangeFilterProps = Pick<
  DateRangeFlexSalesProps<Date>,
  'spacing' | 'requiredIncomplete'
>;

const BusinessRangeFilter = (props: BusinessDateRangeFilterProps) => (
  <ReportBusinessDateRangeFilter
    {...props}
    maxDate={new Date()}
    startDateSelector={reportPendingInterfacesFilterStartBusinessDateSelector}
    endDateSelector={reportPendingInterfacesFilterEndBusinessDateSelector}
    changeStartDateAction={changePendingInterfacesFilterStartBusinessDate}
    changeEndDateAction={changePendingInterfacesFilterEndBusinessDate}
  />
);

export default BusinessRangeFilter;
